import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../../common/constants';
import { MdrtDetail, MdrtFormMode } from '../../types/mdrt-types';
import { fetchMdrtItem } from '../../network/mdrtCrud';
import MdrtDetailForm from './components/MdrtDetailForm';
import { LayoutSplashScreen } from 'src/app/layout';

interface StateMdrtType {
  type: MdrtFormMode;
}

const MdrtDetailPage: FC<RouteComponentProps> = ({ history, location }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode, mdrtId } = useMemo(() => {
    const state = location.state as StateMdrtType;
    return {
      formMode: state.type,
      mdrtId: id ? id : undefined,
    };
  }, [id, location]);

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [mdrtDetail, setMdrtDetail] = useState<MdrtDetail>();

  const reloadData = () => {
    if (mdrtId) {
      setIsLoading(true);
      fetchMdrtItem(mdrtId, dispatch)
        .then((result) => {
          setMdrtDetail(result);
        })
        .catch(() => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [mdrtId]);

  return (
    <>
      {formMode === MdrtFormMode.CREATE && (
        <MdrtDetailForm formMode={formMode} onReload={reloadData} onRouteTo={(route) => history.push(route)} />
      )}
      {formMode !== MdrtFormMode.CREATE &&
        (isLoading || !mdrtDetail ? (
          <LayoutSplashScreen />
        ) : (
          <MdrtDetailForm
            mdrtId={mdrtId}
            formMode={formMode}
            mdrtDetail={mdrtDetail}
            onReload={reloadData}
            onRouteTo={(route) => history.push(route)}
          />
        ))}
    </>
  );
};

export default MdrtDetailPage;
